import Vue from 'vue';

export function registerCommasFilter (): void {
	Vue.filter('commas', (num: number) => {
		if (!num) {
			return num;
		}
		return num.toLocaleString();
	});
}

export function registerCreditsFilter (): void {
	Vue.filter('credits', (num: number) => {
		if (!num) {
			return num;
		}
		return num.toFixed(2);
	});
}
